import { Component, DestroyRef, OnInit, inject, signal } from '@angular/core';
import { Organization } from '../organization/organization-models';
import { AdmOrgTypeaheadComponent } from 'src/app/shared/components/adm-org-typeahead/adm-org-typeahead.component';
import { FeatureFlagService } from 'src/app/shared/services/feature-flag.service';
import { FEATURE_FLAGS } from 'src/app/shared/services/feature-flags.const';
import { tap } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatDialog } from '@angular/material/dialog';
import { CustomerEntranceDialogComponent } from 'src/app/shared/components/customer-entrance-dialog/customer-entrance-dialog.component';

@Component({
  selector: 'adm-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  imports: [AdmOrgTypeaheadComponent],
})
export class HomeComponent implements OnInit {
  private featureFlagService = inject(FeatureFlagService);
  private destroyRef = inject(DestroyRef);
  private dialog = inject(MatDialog);

  public customerEntranceFlagEnabled = signal<boolean>(false);

  async ngOnInit(): Promise<void> {
    this.featureFlagService
      .getFeatureFlag(FEATURE_FLAGS.CUSTOMER_ENTRANCE)
      .pipe(
        tap(flagResult => {
          this.customerEntranceFlagEnabled.set(flagResult.result);
        }),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe();
  }

  openCustomerEntranceOverlay(org: Organization | null) {
    if (!org) return;

    this.dialog.open(CustomerEntranceDialogComponent, {
      panelClass: 'customer-entrance-overlay',
      disableClose: false,
      data: { org },
    });
  }
}
